export default "__VITE_ASSET__8b41d341__"